import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { actions } from './slice';

import { AxiosResponse } from 'axios';
import { SiteSettingInterface } from '../types';
import { SelectPageNo, SelectPageSize, SelectSearch, selectSettingFormData, SelectSortColumn, SelectSortDir } from './selector';
import { doAddSiteSetting, doGetSiteSettingList } from 'utils copy/request';
import { openSnackbar } from 'store/reducers/snackbar';
import CatchBlockFunction from 'hooks/CatchBlockFunction';

export function* AddSiteSettingRequest(action: { payload: { callback: any } }) {
  yield delay(500);
  const form: SiteSettingInterface = yield select(selectSettingFormData);
  if (form.picnicPrice == 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please enter picnic price',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  if (form.minPicnicPeople == 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please enter min people',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  if (form.maxPicnicPeople == 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please enter max people',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }

  try {
    const response: AxiosResponse = yield call(doAddSiteSetting, form);
    if (response && !response.data.statusCode) {
      yield put(
        openSnackbar({
          open: true,
          message: response.data.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    yield put(
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: true
      })
    );
    yield call(action?.payload?.callback());
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}

export function* getSiteSettingListRequest() {
  yield delay(500);

  try {
    const pageNo: number = yield select(SelectPageNo);
    const pageSize: number = yield select(SelectPageSize);
    const searchText: string = yield select(SelectSearch);
    const SortColumn: string = yield select(SelectSortColumn);
    const SortDir: string = yield select(SelectSortDir);
    yield put(actions.setLoading(true));
    const response: AxiosResponse = yield call(
      doGetSiteSettingList,
      `?pageNo=${pageNo}&pageSize=${pageSize}${searchText.length > 0 ? '&search=' + searchText : ''}${
        SortColumn.length > 0 ? '&sortColumn=' + SortColumn : ''
      }${SortDir.length > 0 ? '&sortDir=' + SortDir : ''}`
    );
    yield put(actions.setLoading(false));
    if (response && !response.status) {
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      });
      return;
    }
    yield put(actions.setTotalRow(response.data.meta ? response.data.meta.total : 0));
    yield put(actions.setSiteSettingForEdit(response.data));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}

export function* SiteSettingRepoSaga() {
  yield takeLatest(actions.AddSiteSetting, AddSiteSettingRequest);
  yield takeLatest(actions.doGetSiteSettingList, getSiteSettingListRequest);
}
